export default angular
  .module("AliasCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AliasController", [
    "$scope",
    "$stateParams",
    "$rootScope",
    "Aliases",
    "Message",
    "ScriptLoading",
    function (
      $scope,
      $stateParams,
      $rootScope,
      Aliases,
      Message,
      ScriptLoading,
    ) {
      // Obviously, setting rootScope page name to aliases has impact on left menu contents.
      $rootScope.page = "aliases";

      // fetching language from the rootScope.
      $scope.language = $rootScope.loggedUser.language;
      $scope.isNameValid = true;

      $scope.groups = [
        { id: 1, name: "Diagnosis" },
        { id: 3, name: "Drug" },
        { id: 5, name: "Result" },
        { id: 11, name: "Procedure" },
        { id: 13, name: "Risk" },
        { id: 14, name: "Vaccination" },
      ];

      $scope.changeAliasGroup = (entity, field) => {
        $scope.systemAlias.ALIAS_GROUP = $scope.systemAlias.aliasGroup.id;
        $scope.changedField(entity, field, true);
      };

      $scope.isResultAlias = () => {
        const resultGroup = ($scope.groups.find(g => g.name === "Result") || {}).id;
        return $scope.systemAlias && $scope.systemAlias.ALIAS_GROUP === resultGroup;
      };

      // If field is changed in alias details. Trigger this. This has impact
      // what will be saved when user clicks save.
      $rootScope.changedFields = new Map();
      $scope.changedField = (entity, field, isAliasMetaFormValid, isNameField = false) => {
        $rootScope.changedFields.set(entity, true);
        $rootScope.isAliasMetaFormValid = isAliasMetaFormValid;
        $scope.isNameValid = true;
        if (isNameField && $scope.systemAlias.NAME !== $scope.systemAlias.ORIGINAL_NAME) {
          $rootScope.aliases.find((el) => {
            if (el.NAME === $scope.systemAlias.NAME) {
              $scope.isNameValid = false;
              $rootScope.isAliasMetaFormValid = false;
            }
            return 0;
          });
        }
      };

      // list of scripts messages/tasks
      const loadMessages = aliasId => Message
        .loadMessagesLinkedToAlias(aliasId, (data, status) => {
          $scope.messagesofscript = data;
          if ($scope.messagesofscript) {
            $scope.messagesofscript.forEach((item) => {
              item.TITLE = (item.TITLE || "").replace(/<\/?[^>]+>/gi, "");
            });
          }
          if (status === 200) {
            ScriptLoading
              .markCommentsMessagesTasksResourceLoaded("messagesLinked");
          }
        });

      $scope.$on("loadScriptMessage", (e, params) => {
        loadMessages(params);
      });

      const openAlias = (aliasId) => {
        $rootScope.changedFields = new Map();
        $rootScope.page = "aliasDetails";
        $rootScope.pageId = aliasId;

        $scope.showDetailsBox = true;

        Aliases.loadAliasById(aliasId, (data) => {
          $scope.systemAlias = data;
          $scope.systemAlias.ORIGINAL_NAME = data.NAME;
          $scope.systemAlias.aliasGroup = $scope.groups
            .find(el => el.id === data.ALIAS_GROUP);

          $("#alias-list-content").collapse("hide");
        });

        Aliases.loadMeasurementByAliasId(aliasId, (data) => {
          $scope.systemMeasurement = data;
        });
      };


      // Used with alias loading
      $scope.isAllLoaded = false;
      $scope.showDetailsBox = false;

      // Parse alias' id from url
      const aliasId = $stateParams.id;
      if (aliasId) {
        openAlias(aliasId);
        loadMessages(aliasId);
      }
    },
  ]);
